<template>
    <a class="card-title-help dyor-logo"
        target="_blank"
        v-bind:href="link"
    >
        <dyor-logo />
    </a>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import DyorLogo from '@img/advertise/logos/dyor-symbol.svg?inline';

export default {
    props: {
        address: {
            type: String,
        },
    },

    computed: {
        link() {
            if (!this.address) return 'https://dyor.io/';
            return 'https://dyor.io/token/' + this.address;
        },
    },

    components: {
        DyorLogo,
    },
};
</script>

<style scoped lang="scss">
.dyor-logo {
    position: relative;
    //display: block;
    margin-right: -5px;
    color: var(--body-muted-text-color);

    svg {
        width: 32px;
        height: 32px;
    }
}
</style>
